var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilityPendingShift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.7 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #565d6d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.52,11.65v1.98l1.42.9M11.52,2.65h1.78c.47,0,.92.19,1.26.53.33.34.52.8.52,1.27v.75M4.41,2.65h-1.78c-.47,0-.92.19-1.26.53s-.52.8-.52,1.27v12.6c0,.48.19.94.52,1.27.33.34.79.53,1.26.53h1.78M16.85,13.45c0,2.98-2.39,5.4-5.33,5.4s-5.33-2.42-5.33-5.4,2.39-5.4,5.33-5.4,5.33,2.42,5.33,5.4ZM5.29.85h5.33c.49,0,.89.4.89.9v1.8c0,.5-.4.9-.89.9h-5.33c-.49,0-.89-.4-.89-.9v-1.8c0-.5.4-.9.89-.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityPendingShift);
export default __webpack_public_path__ + "static/media/facility-pending-shift.25803f21bfc8e40340cb75afba82e6e2.svg";
export { ForwardRef as ReactComponent };